const zIndexes = {
  debugBar: 2e4,
  loadingOverlay: 1e4,
  toast: 900,
  menuMobileOverlay: 850,
  modal: 800,
  bottomOverlay: 760,
  filtersModal: 750,
  lightGallery: 700,
  menuOverlay: 600,
  topPopups: 550,
  menu: 500,
  floatingButtons: 400
};
export {
  zIndexes
};
